import { render, staticRenderFns } from "./wall-data.vue?vue&type=template&id=c9f69fda&scoped=true"
import script from "./wall-data.vue?vue&type=script&lang=js"
export * from "./wall-data.vue?vue&type=script&lang=js"
import style0 from "./wall-data.vue?vue&type=style&index=0&id=c9f69fda&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f69fda",
  null
  
)

export default component.exports